module.exports = __webpack_public_path__ + "img/Desk Stationary A39.1670c4b0.jpg";